import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SimpleGrid, Flex } from '@chakra-ui/core';
import { Card } from './Card';
import { I18nTranslateContext } from './I18nContext';

export const CardGrid = ({ cards, onCardClicked }) => {
  const t = useContext(I18nTranslateContext);
  return (
    <SimpleGrid columns={[2, 2, 3, 6]} spacing={2}>
      {cards.map(({ id, src, votes, username, score, ownedByStoryteller }) => (
        <Flex key={id} direction="column" alignItems="center">
          {username && (
            <span className="card-owner">
              {t('card.owner', username.split('@')[0])}
              {score !== undefined && score !== 0 ? ` (+ ${score})` : ''}
            </span>
          )}
          <Card id={id} src={src} votes={votes || []} onClick={onCardClicked} bordered={ownedByStoryteller || false} />
        </Flex>
      ))}
    </SimpleGrid>
  );
};

CardGrid.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      username: PropTypes.string,
      score: PropTypes.number,
    })
  ),
};
